import {
  DeleteClassPostCommentMutation,
  DeleteClassPostCommentMutationVariables,
} from "@outschool/gql-frontend-generated";
import { Reference, useMutation } from "@outschool/ui-apollo";
import { deleteClassPostCommentMutation } from "@outschool/ui-components-classroom";
import React from "react";

export function useLearnerDeleteClassPostCommentMutation() {
  const [mutate] = useMutation<
    DeleteClassPostCommentMutation,
    DeleteClassPostCommentMutationVariables
  >(deleteClassPostCommentMutation);

  return React.useCallback(
    async ({
      classPostUid,
      commentUid,
    }: {
      classPostUid: string;
      commentUid: string;
    }) => {
      await mutate({
        variables: { classPostCommentUid: commentUid },
        update(cache) {
          cache.modify({
            id: cache.identify({ __typename: "ClassPost", uid: classPostUid }),
            fields: {
              comments(existing, { readField }) {
                if (!Array.isArray(existing)) {
                  return existing;
                }
                return (existing as readonly Reference[]).filter(
                  commentRef => readField("uid", commentRef) !== commentUid,
                );
              },
            },
          });
        },
      });
    },
    [mutate],
  );
}
